export class StaffKind {
  constructor() {}
  _id: string;
  name: string;
  description: string;
  type: number;
}
